import { cn } from '@packages/shared/src/utils/cn/cn';
import type { HTMLAttributes } from 'react';

type ContentProps = HTMLAttributes<HTMLDivElement> & {
  smallText: string;
  bigText: string;
};

export const Content = ({ smallText, bigText, className, ...props }: ContentProps) => (
  <div className={cn('flex w-1/2 flex-col items-center', className)} {...props}>
    <p className="text-size-body3">{smallText}</p>
    <p className="text-size-h3 mt-0.5">{bigText}</p>
  </div>
);
